'use client';

import { useState, useEffect } from 'react';
import Icon from '@/components/ui/AppIcon';

interface StickyContactBarProps {
  onContactClick?: () => void;
}

const StickyContactBar = ({ onContactClick }: StickyContactBarProps) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const heroSection = document.getElementById('hero');
      const contactSection = document.getElementById('contact');

      if (heroSection && contactSection) {
        const heroBottom = heroSection.offsetTop + heroSection.offsetHeight;
        const contactTop = contactSection.offsetTop;
        const scrollPosition = window.scrollY + window.innerHeight;

        setIsVisible(window.scrollY > heroBottom && scrollPosition < contactTop);
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleClick = () => {
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      const offsetPosition = contactSection.offsetTop - 80;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth',
      });
    }

    if (onContactClick) {
      onContactClick();
    }
  };

  return (
    <div
      className={`lg:hidden fixed bottom-0 left-0 right-0 z-40 transition-all duration-250 ${
        isVisible ? 'translate-y-0 opacity-100' : 'translate-y-full opacity-0'
      }`}
    >
      <div className="bg-card border-t border-border shadow-lg">
        <div className="flex items-center gap-3 px-6 py-4">
          <a
            href="tel:+48667009004"
            className="flex items-center justify-center w-12 h-12 bg-secondary text-secondary-foreground rounded-lg transition-all duration-250 hover:bg-secondary/90"
            aria-label="Zadzwoń"
          >
            <Icon name="PhoneIcon" size={20} variant="outline" />
          </a>
          <button
            onClick={handleClick}
            className="flex-1 px-6 py-3 bg-accent text-accent-foreground font-body font-semibold rounded-lg shadow-cta transition-all duration-250 hover:bg-accent/90 hover:shadow-lg"
          >
            Umów bezpłatną konsultację
          </button>
        </div>
      </div>
    </div>
  );
};

export default StickyContactBar;